"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReturnLinkService = void 0;
class ReturnLinkService {
    generateReturnLink(token) {
        let urlParams = new URLSearchParams(window.location.search);
        urlParams.set('px-valuation-token', token);
        return `${location.origin}${location.pathname}?${urlParams}`;
    }
    getReturnTokenFromUrl() {
        let urlParams = new URLSearchParams(window.location.search);
        return urlParams.get('px-valuation-token') || null;
    }
}
exports.ReturnLinkService = ReturnLinkService;
